export default function exportToExcel(headerFields, data, fileName){
    // Convert data and fields to CSV format
    const csv = [headerFields.map((f) => f.label).join(",")];
    data.forEach((item) => {
      item;
      const values = headerFields.map((c, f) => {
        return eval("item['"+ headerFields[f].key.split('.').join("']['") +"']")
      });
      csv.push(values.join(","));
    });
    // Download the CSV file
    const blob = new Blob(["\ufeff" + csv.join("\n")], {
      type: "text/csv;charset=utf-8;",
    });
    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", fileName + ".csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
}